import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMerchantOrderSharedLinksForEventTableQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  filter?: Types.InputMaybe<Types.MerchantOrderSharedLinksFilter>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetMerchantOrderSharedLinksForEventTableQuery = { __typename?: 'Query', getMerchantOrderSharedLinksForEvent: { __typename?: 'GetMerchantOrderSharedLinksForEventResponse', total: number, eventMerchantorderSharedLinks: Array<{ __typename?: 'MerchantOrderSharedLink', id: string, sales_order_url?: string | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null } | null, merchant_order?: { __typename?: 'MerchantOrderInfo', id: string, delivery_note_id: number, status: Types.MerchantOrderStatusEnum, latest_revision?: { __typename?: 'MerchantOrderRevisionInfo', containers: Array<{ __typename?: 'MerchantOrderContainerInfo', type_id: number, amount_int: number, unit: Types.MerchantOrderItemUnit }>, items: Array<{ __typename?: 'MerchantOrderItemInfo', item_type_id: number, amount_int: number, unit: Types.MerchantOrderItemUnit, item_type?: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null } | null }> } | null } | null }> }, event?: { __typename?: 'Event', allowed_container_types: Array<{ __typename?: 'ContainerType', id: number, packing_unit?: number | null }> } | null };


export const GetMerchantOrderSharedLinksForEventTableDocument = gql`
    query GetMerchantOrderSharedLinksForEventTable($eventId: ID!, $filter: MerchantOrderSharedLinksFilter, $skip: Int, $take: Int) {
  getMerchantOrderSharedLinksForEvent(
    event_id: $eventId
    filter: $filter
    skip: $skip
    take: $take
  ) {
    total
    eventMerchantorderSharedLinks {
      id
      sales_order_url
      event_account {
        id
        name
      }
      merchant_order {
        id
        delivery_note_id
        status
        latest_revision {
          containers {
            type_id
            amount_int
            unit
          }
          items {
            item_type_id
            amount_int
            unit
            item_type {
              id
              name
              image_url
              color_hex_code
            }
          }
        }
      }
    }
  }
  event(id: $eventId) {
    allowed_container_types {
      id
      packing_unit
    }
  }
}
    `;

/**
 * __useGetMerchantOrderSharedLinksForEventTableQuery__
 *
 * To run a query within a React component, call `useGetMerchantOrderSharedLinksForEventTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMerchantOrderSharedLinksForEventTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMerchantOrderSharedLinksForEventTableQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetMerchantOrderSharedLinksForEventTableQuery(baseOptions: Apollo.QueryHookOptions<GetMerchantOrderSharedLinksForEventTableQuery, GetMerchantOrderSharedLinksForEventTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMerchantOrderSharedLinksForEventTableQuery, GetMerchantOrderSharedLinksForEventTableQueryVariables>(GetMerchantOrderSharedLinksForEventTableDocument, options);
      }
export function useGetMerchantOrderSharedLinksForEventTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMerchantOrderSharedLinksForEventTableQuery, GetMerchantOrderSharedLinksForEventTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMerchantOrderSharedLinksForEventTableQuery, GetMerchantOrderSharedLinksForEventTableQueryVariables>(GetMerchantOrderSharedLinksForEventTableDocument, options);
        }
export type GetMerchantOrderSharedLinksForEventTableQueryHookResult = ReturnType<typeof useGetMerchantOrderSharedLinksForEventTableQuery>;
export type GetMerchantOrderSharedLinksForEventTableLazyQueryHookResult = ReturnType<typeof useGetMerchantOrderSharedLinksForEventTableLazyQuery>;
export type GetMerchantOrderSharedLinksForEventTableQueryResult = Apollo.QueryResult<GetMerchantOrderSharedLinksForEventTableQuery, GetMerchantOrderSharedLinksForEventTableQueryVariables>;